import useFetch from "react-fetch-hook";
import LangPrefPage from "./langPrefPage";
import { LanguageOptions } from "../models/LanguageOptions";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function LangPrefPageHOC() {
  //const url = 'https://b55a3739-4d24-44f3-aa30-7a3d1cddefa1.mock.pstmn.io/langPref'
  //const { isLoading, data } = useFetch(url);
  const { t } = useTranslation();

  useEffect(() => {
    console.log("Clearing local storage");
    localStorage.clear();
  }, []);

  const options = new LanguageOptions().options.map((option) => {
    return {
      group: "language",
      className: "language_selection",
      value: option.code,
      text: option.name,
      id: option.code,
    };
  });

  const data = {
    question: t("onboard.LANG_PREF.question"),
    choices: options,
  };

  return data == undefined ? (
    <div>Loading...</div>
  ) : (
    <LangPrefPage data={data} />
  );
}

export default LangPrefPageHOC;
